"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
const lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
function default_1(event, prevState = {}) {
    var _a;
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const existingTables = (0, utils_1.getTablesFromOrder)(order) || [];
    const tableStatus = ((_a = existingTables[0]) === null || _a === void 0 ? void 0 : _a.status) || domain_1.TableStatus.OCCUPIED;
    const filteredTables = existingTables.filter(table => !event.transferTablesFrom.some(fromTable => fromTable.tableId === table.id));
    const newTables = event.transferTablesTo.map(table => ({
        id: table.tableId,
        name: table.tableName,
        guestCount: table.guestCount,
        status: tableStatus,
        ...(table.sectionId && {
            section: {
                id: table.sectionId,
                name: table.sectionName,
            },
        }),
    }));
    order.tables = (0, lodash_uniqby_1.default)([...newTables, ...filteredTables], 'id');
    order.table =
        order.tables.find(table => { var _a; return table.id === ((_a = order.table) === null || _a === void 0 ? void 0 : _a.id); }) || order.tables[0];
    return order;
}
exports.default = default_1;
//# sourceMappingURL=transferTables.js.map